import { render, staticRenderFns } from "./lawsModal.vue?vue&type=template&id=749bfa88&scoped=true&"
import script from "./lawsModal.vue?vue&type=script&lang=js&"
export * from "./lawsModal.vue?vue&type=script&lang=js&"
import style0 from "./lawsModal.vue?vue&type=style&index=0&id=749bfa88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749bfa88",
  null
  
)

export default component.exports